<template>
  <v-card>
    <HeaderDividerBlock headerText="Edit Tax" />
    <v-form ref="taxForm" v-model="valid">
      <v-container>
        <v-row>
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
                  <p class="text-title">Tax Code*</p>
                </v-col>
            <v-text-field
              v-model="form.tax_code"
              placeholder="Enter Tax Code*"
              outlined
              dense
              required
            />
          </v-col>
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
                              <p class="text-title">Name*</p>
            </v-col>
            <v-text-field
              v-model="form.name"
              placeholder="Enter Name*"
              outlined
              dense
              required
            />
          </v-col>
          <v-col cols="6">
            <v-col class="pa-0 ma-0">
                              <p class="text-title">Rate (%)*</p>
                            </v-col>
            <v-text-field
              v-model="form.rate"
              placeholder="Enter Rate (%)*"
              outlined
              dense
              type="number"
              required
            />
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
              <p class="text-title">Effective From</p>
            </v-col>
            <DatePicker
              v-model="form.effective_from"
              placeholder="Effective From"
              :rules="[(v) => true]"
            />
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
                              <p class="text-title">Effective To</p>
                            </v-col>
            <DatePicker
              v-model="form.effective_to"
               placeholder="Effective To"
              :min="form.effective_from"
            />
          </v-col>

          <v-col cols="6">
            <v-col class="pa-0 ma-0">
                              <p class="text-title">Status</p>
                            </v-col>
            <v-autocomplete
              v-model="form.status"
              :items="['ACTIVE', 'INACTIVE']"
              placeholder="Select Status"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="2" xs="6">
            <v-btn large color="#00B3FF" dark depressed block @click="submit" loading:="loading" :disabled="!valid">
              Update Tax</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="snackbar = false"
    />
    <Alert v-if="errors" :text="errors" @dismissed="errors = null" />
  </v-card>
</template>

<script>
import HeaderDividerBlock from "@/components/shared/HeaderDividerBlock";
import Snackbars from "@/components/shared/Snackbars";
import Alert from "@/components/shared/Alert";
import { TaxService } from "@/services/tax-service.js";
import { checkError } from "@/config/errors.js";
import DatePicker from "@/components/shared/DatePicker";

export default {
  name: "TaxEditForm",
  components: { HeaderDividerBlock, Snackbars, Alert, DatePicker },
  data() {
    return {
      form: {
        tax_code: "",
        name: "",
        rate: "",
        status: "ACTIVE",
        effective_from: "",
        effective_to: "",
      },
      valid: false,
      loading: false,
      successMsg: "",
      snackbar: false,
      errors: null,
    };
  },
  mounted() {
    this.fetchTax();
  },
  methods: {
    fetchTax() {
      this.loading = true;
      TaxService.getTaxDetails(this.$route.params.uuid)
        .then((res) => {
          Object.assign(this.form, res.data.data);
        })
        .catch((error) => {
          let data = error.response?.data;
          this.errors = checkError.errorFormatting(data);
        })
        .finally(() => (this.loading = false));
    },
    submit() {
      this.loading = true;
      TaxService.updateTax(this.$route.params.uuid, this.form)
        .then(() => {
          this.successMsg = "Tax updated successfully";
          this.snackbar = true;
          this.$router.push({ name: "TaxList" });
        })
        .catch((error) => {
          let data = error.response?.data;
          this.errors = checkError.errorFormatting(data);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
